import { useSelector } from 'react-redux';

import { RootState } from '../../rootReducer';

export const useQuotesToTagsLoading = (): Record<string, boolean> => {
  return useSelector<RootState, Record<string, boolean>>(
    state => state.quotesToTags.loading
  );
};
